export default "__VITE_ASSET__BXWERLJc__"